export default __webpack_public_path__ + "static/media/team1.706c11a2.jpeg";